import { isSupportTicketRouteId } from "@redotech/redo-merchant-links/links";
import { ACTIVE_CONVERSATION_QUERY_PARAMETER } from "@redotech/redo-merchant-support-app/query-parameters";
import { memo } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

// Redirects any deprecated support-v1 path (inbox, dashboard, llm-thread) to
// its support-v2 equivalent. Mounted on the `/support/*` catch-all,
// which renders outside the layout that provides the team context.
export const SupportV1Redirect = memo(function SupportV1Redirect() {
  const location = useLocation();
  const params = useParams();
  const base = `/stores/${params.teamId}/support-v2`;
  const rest = params["*"] ?? "";

  if (rest === "dashboard" || rest.startsWith("dashboard/")) {
    return <Navigate replace to={`${base}/dashboard`} />;
  }

  const conversationId =
    new URLSearchParams(location.search).get(
      ACTIVE_CONVERSATION_QUERY_PARAMETER,
    ) || undefined;

  const target =
    conversationId && isSupportTicketRouteId(conversationId)
      ? `${base}/${conversationId}`
      : base;

  return <Navigate replace to={target} />;
});
